export type PrismaTableRef = {
  clearSelection?: () => void;
  $refs?: {
    tableRef?: {
      clearSelection: () => void;
    };
  };
};

export const clearPrismaTableSelection = (
  table: PrismaTableRef | null | undefined
) => {
  if (table?.clearSelection) {
    table.clearSelection();

    return;
  }

  table?.$refs?.tableRef?.clearSelection();
};
